<div class="details-body-wrapper">
  <app-users-list
    [filters]="filters"
    [entityType]="'client'"
    [addPermission]="'create client user'"
  >
  </app-users-list>
</div>
